export default {
  Add: 'افزودن',
  Addresses: 'آدرس ',
  AddUser: 'ثبت کاربر جدید',
  Another: 'سایر',
  Account: 'حساب کاربری',
  ActiveShipment: 'سفارش‌های فعال',
  AppVersion: 'نسخه های اپلیکیشن',
  AssignedToDriver: ' اختصاص یافته راننده',
  BaseInfo: 'اطلاعات پایه',
  CurrentLoads: 'سفارش‌های جاری',
  Commander: 'دستور دهندگان',
  CustomerApprovedRequest: 'تایید شده مشتری',
  CompanyApprovedRequest: 'تایید شده پروژه',
  Books: 'کتاب',
  Bank: 'بانک',
  BankAccount: 'حساب بانکی',
  ChangePassword: 'ویرایش رمز عبور',
  Comments: 'دیدگاه ',
  CouponTypes: 'انواع کوپن تخفیف',
  Coupones: 'کوپن تخفیف',
  Countrys: 'کشور',
  County: 'شهرستان',
  Contacts: 'تماس ',
  Colors: 'رنگ ',
  CarManage: ' خودرو',
  Calendar: 'تقویم',
  CalendarTrafficPlan: 'طرح ترافیک',
  CompanyExtraTrafficPlan: 'طرح ترافیک',
  CarLiveLocation: 'موقعیت راننده ',
  CarOptiones: 'آپشن',
  CarController: ' خودرو ',
  CompanyManage: 'پروژه ',
  CreateCompany: 'ثبت پروژه جدید',
  CompanyExtra: 'تعرفه ',
  CompanyExtraCar: ' خودرو',
  CompanyExtraItem: ' اقلام',
  CompanyExtraEmployee: ' افراد',
  CompanyExtraTariff: 'تعرفه',
  CompanyController: 'پروژه ',
  CarModel: 'خانواده خودرو',
  CarFeature: 'نوع خودرو',
  CarLoad: 'بارگیر',
  CarBrand: 'برند',
  Category: 'دسته',
  Citys: 'شهر',
  Crm: 'ارتباط با مشتری',
  Campaign: 'کمپین',
  Currency: 'پول',
  Dashboard: 'پیش خوان',
  Details: 'جزییات',
  Discount: 'تخفیف',
  DriverTraining: 'مراحل کار  راننده',
  Driver: 'راننده',
  Decision: 'تصمیم گیری',
  Department: 'دپارتمان',
  EditCargo: 'ویرایش سفارش',
  Expectation: 'انتظار بارگیری',
  Edit: 'ویرایش',
  EditOrder: 'ویرایش سفارش',
  Employee: 'افراد',
  Email: 'پست الکترونیکی',
  Feedback: 'بازخورد',
  Financial: 'مالی',
  FeaturController: ' خصوصیات',
  FeedbackCriterion: 'معیار ',
  GiftCardTypes: 'انواع کارت هدیه',
  GiftCards: 'کارت هدیه',
  GenarateCoupones: 'افزودن انبوه کوپن',
  GenerateGiftCard: 'افزودن انبوه کارت هدیه',
  Home: 'خانه',
  Holding: 'هلدینگ ',
  Holiday: 'تعطیلات',
  Index: 'لیست',
  Info: 'اطلاعات',
  Item: 'اقلام',
  ItemGroup: 'گروه اقلام',
  ItemController: 'خانواده اقلام',
  ItemFeature: 'نوع اقلام',
  Licenses: 'مجوز',
  branch: 'شعبه',
  Load: 'نوع بار',
  Menu: 'منو',
  Media: 'رسانه',
  Measurement: 'اندازه گیری',
  Messenger: 'پیام رسان',
  Notification: 'اطلاعیه',
  Provinces: 'استان ',
  Organization: 'سازمان',
  Payment: 'پرداخت',
  Geolocations: 'مناطق جغرافیایی',
  Pages: 'برگه ',
  Packages: 'بسته بندی',
  Profile: 'اطلاعات شخصی',
  Permission: 'سطوح دسترسی',
  Past: 'تمام شده',
  Policy: 'سیاست',
  Promotions: 'پیشنهاد ویژه',
  Read: 'مطالعه',
  Realm: 'حوزه دید',
  Role: 'نقش',
  RegisterOrder: 'ثبت سفارش',
  Respond: 'پاسخ دادن',
  ReportMessenger: 'گزارش پیام ها',
  ShipmentDetails: 'پارامترهای سفارش',
  Size: 'اندازه ',
  Security: 'امنیت',
  Session: 'نشست ',
  UserSession: 'نشست کاربران',
  Sections: 'بخش های کتاب',
  Subject: 'موضوع',
  ContactSubject: 'موضوع تماس',
  SubCategory: 'زیردسته',
  Settings: 'تنظیمات',
  shipment: ' سفارش',
  SpeedDrivers: 'سرعت راننده',
  ShipmentreportsAll: 'سفارش‌ها',
  shipmentReport: 'گزارش سفارش',
  pointsReport: 'گزارش مبدا و مقصد',
  Sms: 'پیامک',
  Statistics: 'آمار',
  Ticket: 'تیکت',
  TicketMessage: 'پیام های تیکت',
  Transport: 'ترابری',
  TrafficPlan: 'طرح ترافیک',
  Tariff: 'تعرفه',
  Users: 'کاربران',
  UserController: ' کاربران',
  UserGroup: 'گروه کاربران',
  UnitController: ' واحد',
  UrlShortened: 'کوتاه کننده لینک‌',
  Url: 'لینک‌',
  Variable: 'متغیر سیستمی',
  Widgets: 'ابزارک ',
  widgets: 'ابزارک',
  WebServices: 'درگاه',
  Zons: 'مناطق',
  LogReporter: 'لیست تغییرات',
  CarReportLogs: 'لیست تغییرات تعرفه ماشین',
  ItemReportLogs: 'لیست تغییرات تعرفه اقلام',
  ExtraReportLogs: 'لیست تغییرات تعرفه خاص',
  EmployeeReportLogs: 'لیست تغییرات تعرفه نیروی فنی',
  AuctionReportLogs: 'لیست تغییرات مزایده',
  TrafficPlanReportLogs: 'لیست تغییرات تعرفه طرح ترافیک',
  CloneOrder: 'سفارش دوباره',
  Furniture: 'اسباب‌کشی',
  Cargo: 'بار سنگین',
  License: 'گواهینامه',
  LicenseType: 'نوع گواهینامه',
  Operator: 'اپراتور',
  Appropriation: 'تخصیص سفارش',
  Live: 'موقعیت لحظه‌ای',
  Trajectory: 'خط سِیر',
  CurrentTrajectory: 'مسیر جاری',
  TariffAuction: 'مزایده',
  Location: 'موقعیت مکانی',
  System: 'سیستم',
  CMS: 'مدیریت محتوا',
  Faq: 'سوالات متداول',
  Reasons: 'دلایل',
  Cancel: 'کنسلی',
  ShipmentTemplate: 'الگوی سفارش',
  ShipmentDraft: 'پیش نویس سفارش',

  // refactor
  add: 'افزودن',
  approve: 'تایید',
  edit: 'ویرایش',
  home: 'خانه',
  baseInfo: 'اطلاعات پایه',
  carModel: 'خانواده خودرو',
  carLoad: 'بارگیر',
  carFeature: 'نوع خودرو',
  carBrand: 'برند',
  shipmentDetails: 'پارامترهای سفارش',
  employee: 'نیروی فنی',
  itemGroup: 'گروه اقلام',
  item: 'اقلام',
  itemController: 'خانواده اقلام',
  itemFeature: 'نوع اقلام',
  load: 'نوع بار',
  packages: 'بسته بندی ها',
  package: 'بسته',
  carton: 'کارتن',
  reasons: 'دلایل',
  cancel: 'کنسلی',
  organization: 'سازمان',
  feedbackCriterion: 'معیار ',
  feedbackPointCriterion: 'نقاط ضعف و قوت',
  referrerType: 'انواع معرف',
  club: 'باشگاه مشتریان',
  userGroup: 'گروه کاربران',
  userLevel: 'سطح کاربران',
  category: 'دسته',
  subject: 'موضوع',
  subCategory: 'زیردسته',
  media: 'رسانه',
  department: 'دپارتمان',
  crm: 'ارتباط با مشتری',
  policy: 'سیاست',
  bank: 'بانک',
  bankAccount: 'حساب بانکی',
  financial: 'مالی',
  courierEquipment: 'تجهیزات پروژه',
  equipment: 'تجهیزات',
  courier: 'پروژه',
  expertise: 'حوزه کاری',
  courierExpertise: 'حوزه کاری پروژه',
  courierLicenseType: 'نوع مجوز',
  courierLicenseCategory: 'دسته مجوز',
  users: 'کاربران',
  licenseType: 'نوع گواهینامه',
  educationLevel: 'سطح تحصیلات',
  contract: 'قرارداد',
  contractCategory: 'دسته قرارداد',
  cms: 'مدیریت محتوا',
  postCategory: 'دسته پست',
  themeCategory: 'دسته تم',
  theme: 'تم',
  faqCategory: 'دسته سوالات متداول',
  questionnaire: 'پرسشنامه',
  questionCategory: 'دسته پرسش',
  question: 'سوال',
  answer: 'پاسخ',
  survey: 'نظر سنجی',
  geoLocations: 'مناطق جغرافیایی',
  country: 'کشور',
  province: 'استان',
  county: 'شهرستان',
  city: 'شهر',
  district: 'ناحیه',
  trafficPlan: 'طرح ترافیک',
  unit: 'واحد',
  currency: 'پول',
  measurement: 'اندازه گیری',
  color: 'رنگ',
  size: 'اندازه',
  featurController: ' خصوصیات',
  holiday: 'تعطیلات',
  calendar: 'تقویم',
  usersReport: 'گزارش کاربران',
  customersReport: 'گزارش مشتریان',
  customers: 'مشتریان',
  adminsReport: 'گزارش مدیران',
  admins: 'مدیران',
  details: 'جزئیات',
  security: 'امنیت',
  realm: 'حوزه دید',
  role: 'نقش',
  userSession: 'نشست کاربران',
  session: 'نشست ',
  operator: 'اپراتور',
  driver: 'راننده',
  live: 'موقعیت لحظه‌ای',
  trajectory: 'خط سِیر',
  address: 'آدرس',
  company: 'پروژه',
  holding: 'هلدینگ ',
  licenses: 'مجوز',
  campaign: 'کمپین',
  promotions: 'پیشنهاد ویژه',
  couponTypes: 'انواع کوپن تخفیف',
  coupons: 'کوپن تخفیف',
  giftCardTypes: 'انواع کارت هدیه',
  giftCards: 'کارت هدیه',
  genarateCoupons: 'افزودن انبوه کوپن',
  generateGiftCard: 'افزودن انبوه کارت هدیه',
  discount: 'تخفیف',
  reports: 'گزارش ها',
  undefinedTariffs: 'تعرفه‌های منقضی‌شده',
  car: 'خودرو',
  auction: 'مزایده',
  specialTariff: 'تعرفه خاص',
  log: 'لاگ',
  tariffs: 'تعرفه ها',
  chart: 'نمودار',
  ticketMessage_: 'پیام تیکت',
  payment: 'پرداخت',
  bankPayment: 'پرداختی بانک',
  authorityLimit: 'حدود اختیارات',
  loads: 'سفارش‌ها',
  area: 'ناحیه ها',
  timeSheet: 'جدول زمانی',
  trafficPlanTemplate: 'الگوی طرح ترافیک',
  courierPlanTemplate: 'الگوی کاری پروژه',
  dictionary: 'دیکشنری',
  landingPage: 'صفحه لندینگ',
  postage: 'مرسوله پستی',
  miss: 'خطای جستجو',
  messages: 'پیام ها',
  sent: 'ارسال شده',
  dictionaryConflict: 'مغایرت دیکشنری',
  conflictWithReferenceSystem: 'مغایرت با سیستم داخلی',
  conflictWithExternalSystem: 'مغایرت با سیستم خارجی',
  record: 'تاریخچه',
  fileAndDocuments: 'فایل و اسناد',
  internal: 'پیام داخلی',
  internalTemplate: 'الگوی پیام داخلی',
  splash: 'splash',
  driver: 'راننده',
  vehicle: 'خودرو',
  delivery: 'پیک',
  pickup: 'بار شهری (وانت)',
  order: 'سفارش',
  license: 'مجوز',
  audit: 'audit',
  exception: 'خطا',
  general: 'عمومی',
  shipmentStatistics: 'نمودار سفارش‌ها',
  companyShipmentStatistics: 'نمودار سفارش پروژه ها',
  userStatistics: 'نمودار کاربران',
  companyScoreStatistics: 'نمودار امتیاز پروژه ها',
  site: 'سایت',
  page: 'صفحه',
  siteGenerator: 'سایت ساز',
  statistics: 'آماری',
  operation: 'عملیات',
  parameter: 'پارامتر',
  driverActivity: 'فعالیت راننده',
  layout: 'چیدمان',
  template: 'الگو',
  operationEditor: 'عملیات کاربران',
  operationAnonymous: 'عملیات کاربران ناشناس',
  limitLicense: 'مجوز حدود اختیارات',
  permissionLicense: 'مجوز سطح دسترسی',
  tariffAuction: 'مزایده',
  carTariff: 'تعرفه خودرو',
  employeeTariff: 'تعرفه نیروی فنی',
  trafficPlanTariff: 'تعرفه طرح ترافیک',
  itemTariff: 'تعرفه اقلام',
  auctiontariff: 'تعرفه مزایده',
  specialTariff: 'تعرفه خاص',
  companyTarrif: 'تعرفه های پروژه',
  companyShipmentSupport: 'پشتیبانی سفارش پروژه',
  faq: 'سوالات متداول',
  contact: 'تماس',
  feedback: 'دیدگاه',
  messenger: 'پیام رسان',
  decision: 'تصمیم گیری',
  sms: 'پیامک',
  email: 'پست الکترونیکی',
  notification: 'اطلاعیه',
  permission: 'سطوح دسترسی',
  ticket: 'تیکت',
  speedDrivers: 'سرعت راننده',
  location: 'موقعیت مکانی',
  transport: 'حمل و نقل',
  shipmentTemplate: 'الگوی سفارش',
  shipmentDraft: 'پیش نویس سفارش',
  codeGenerator: 'کدساز',
  system: 'سیستم',
  settings: 'تنظیمات',
  appVersion: 'نسخه های اپلیکیشن',
  webView: 'وب ویو',
  webServices: 'درگاه',
  urlShortened: 'کوتاه کننده لینک‌',
  url: 'لینک‌',
  registerOrder: 'ثبت سفارش',
  registerTemplate: 'ثبت الگوی سفارش',
  limit: 'حدود اختیارات',
  generalLimits: 'حدود اختیارات عمومی',
  webService: 'وب سرویس',
  temporaryShipment: 'سفارش‌های موقت',
  price: 'قیمت دهی',
  post: 'پست',
  comment: 'نظرات',
  suspend: 'تعلیق',
  loadCategory: 'دسته بار',
  poiCategory: 'دسته آدرس سراسری',
  poi: 'آدرس سراسری',
  soil: 'نوع خاک',
  carManage: ' خودرو',
  content: 'محتوا',
  blog: 'بلاگ',
  tag: 'تگ',
  respond: 'پاسخ',
  materialTariff: 'تعرفه مصالح',
  trashTariff: 'تعرفه نخاله',
  freightTariff: 'تعرفه پیک',
  furnitureTariff: 'تعرفه اسباب‌کشی',
  cargoTariff: 'تعرفه بار',
  attachment: 'پیوست',
  container: 'کانتینر',
  bucket: 'باکت',
  events: 'رویداد ها',
  map: 'نقشه',
  financialAccount: 'حساب',
  commercialBanking: 'بانکداری تجاری',
  trashCar: 'خودرو نخاله',
  trashCarTariff: 'تعرفه خودرو نخاله',
  freightCarTariff: 'تعرفه خودرو پیک',
  packageTypes: 'نوع بسته بندی',
  bill: 'صورتحساب',
  bankCredit: 'اعتبار بانکی',
  wallet: 'کیف پول',
  trash: 'نخاله',
  Trash: 'نخاله',
  freight: 'پیک',
  Freight: 'پیک',
  Material: 'مصالح',
  supported: 'پشتیبانی',
  supportedOrder: 'پشتیبانی بار',
  supportedCourier: 'پشتیبانی پروژه',
  external: 'سیستم خارجی',
  baraneh: 'بارانه',
  Settlement: 'تسویه',
  SupportedRangeType: 'نوع و محدوده بار',
  credential: 'مدارک',
  baadpa: 'بادپا',
  blackList: 'لیست سیاه',
  CourierBlackList: 'لیست سیاه پروژه',
  DriverBlackList: 'لیست سیاه راننده',
  updateLegal: 'ویرایش اطلاعات حقوقی',
  legal: 'حقوقی',
  UserLegal: 'کاربر حقوقی',
  batchOrder: 'سفارش انبوه',
  addon: 'خدمات جانبی',
  loadCondition: 'شرایط ویژه حمل',
  tutorial: 'راهنمای استفاده',
  billOfLading: 'بارنامه',
  ReceivedReport: 'دریافت شده',
  ProcessingReport: 'در حال پردازش',
  PaymentQueueReport: 'در صف پرداخت',
  PaidReport: 'پرداخت شده',
  openBankingPayment: 'پرداختی بانکداری باز',
  shift: 'شیفت'
}
